import { RefObject, useEffect, useLayoutEffect, useRef } from 'react';

const reducedMotion = () =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export const useWidening = (ref: RefObject<HTMLElement>, key: string): void => {
  const lastWidth = useRef(0);
  const flip = useRef(false);

  useEffect(() => {
    const el = ref.current;
    const RO = (window as any).ResizeObserver;
    if (!el || !RO) {
      return undefined;
    }
    const ro = new RO((entries: any[]) => {
      lastWidth.current = entries[0].contentRect.width;
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, [ref]);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) {
      return;
    }
    const next = el.getBoundingClientRect().width;
    const prev = lastWidth.current;
    lastWidth.current = next;
    if (!prev || !next || Math.abs(next - prev) < 1 || reducedMotion()) {
      return;
    }
    el.style.setProperty('--psc-widen-from', String(prev / next));
    flip.current = !flip.current;
    el.dataset.widen = flip.current ? 'a' : 'b';
  }, [ref, key]);
};
